import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { UserPoco, ResponseDTO } from '@data/DTO/DTO';

const CREATE_UPDATE_USER = gql`
    mutation authenticate($input: UserPocoInput!, $password: String!) {
      user {
        addUpdateUser(input: $input, password: $password) {
          success
          error
        }
      }
    }
`;

const DELETE_USER = gql`
  mutation user($id: Long!) {
    user {
      deleteUser(id: $id) {
        error
        message
        success
        totalRecord
      }
    }
  }
`;

const GET_USER_BY_ID = gql`
  query user($id: Long!) {
    user {
      userByID(id: $id) {
        success
        error
        data {
          id
          firstName
          lastName
          email
          nric
          phoneNumber
          refRole {
            id
            name
          }
        }
      }
    }
  }
`;

const GET_LIST_USERS = gql`
  query user($pageNo: Int!, $refRoleId: Long) {
    user {
        listUser(pageNo: $pageNo, refRoleId: $refRoleId) {
          success
          error
          totalRecord
          data {
            id
            guid
            email
            firstName
            isActive
            lastName
            phoneNumber
            nric
            refRole {
              id
              name
            }
          }
        }
    }
  }
`;

const AUTHENTICATE_USER = gql`
  query authenticate($email: String!, $password: String!) {
    user {
        authenticate(email: $email, password: $password) {
            success
            error
            data {
                id
                firstName
                lastName
                email
                phoneNumber
                token
                refRole {
                  id
                  name
                }
            }
        }
    }
 }
`;

@Injectable({
  providedIn: 'root',
})
export class ApolloUserService {
  constructor(private apollo: Apollo) { }

  createUpdateUser(user: Partial<UserPoco>, password: string): Observable<ResponseDTO<UserPoco>> {
    return this.apollo.mutate({
      mutation: CREATE_UPDATE_USER,
      variables: { input: user, password },
    }).pipe(
      map((result: any) => result.data?.user?.addUpdateUser)
    );
  }

  deleteUser(id: number): Observable<ResponseDTO<UserPoco>> {
    return this.apollo.mutate({
      mutation: DELETE_USER,
      variables: { id },
    }).pipe(
      map((result: any) => result.data?.user?.deleteUser)
    );
  }

  getUserById(id: number): Observable<ResponseDTO<UserPoco[]>> {
    return this.apollo.query({
      query: GET_USER_BY_ID,
      variables: { id },
    }).pipe(
      map((result: any) => result.data?.user?.userByID)
    );
  }

  getListUser(pageNo: number = 1, refRoleId?: number): Observable<ResponseDTO<UserPoco[]>> {
    return this.apollo.query({
      query: GET_LIST_USERS,
      variables: { pageNo, refRoleId },
    }).pipe(
      map((result: any) => result.data?.user?.listUser)
    );
  }

  authenticate(email: string, password: string): Observable<ResponseDTO<UserPoco>> {
    return this.apollo.watchQuery<any>({
      query: AUTHENTICATE_USER,
      variables: { email, password },
    }).valueChanges.pipe(
      map(result => {
        return result.data?.user?.authenticate;
      })
    );
  }
}